import React from 'react';
import { FormattedMessage } from 'react-intl';
import BreadcrumbContainer from 'components/layout/breadcrumb_container';
import IndexContainer from 'components/inspection_subject/index_container';
import { BreadCrumbTypography } from 'components/styles_components/typography';
import { PaginateProvider } from 'contexts/paginate';
import Container from 'components/layout/container';
import TopMenu from 'components/layout/top_menu';

const InspectionSubjects = () => {
  return (
    <PaginateProvider>
      <TopMenu>
        <BreadcrumbContainer>
          <BreadCrumbTypography>
            <FormattedMessage id="breadcrumb.inspection_subjects.index" />
          </BreadCrumbTypography>
        </BreadcrumbContainer>
      </TopMenu>
      <Container>
        <IndexContainer />
      </Container>
    </PaginateProvider>
  );
};

export default InspectionSubjects;
